// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.maintenanceBlock___M3Q5 {
  width: 100%;
}

.maintenanceTitle__p2PAH {
  font-size: 11px;
  line-height: 13px;
  color: var(--title-inputs-sections-title);
  text-transform: uppercase;
}

.maintenanceTable__daZBl {
  width: 100%;
  margin-top: 10px;
}

.maintenanceTableHead__RW9Nr {
  background: var(--tables-title-surface);
}

.maintenanceTableTh__aVQoj {
  font-size: 10px;
  font-weight: 400;
  line-height: 12px;
  color: var(--tables-title-text);
  text-transform: uppercase;
  text-align: left;
  padding: 15px 0;
  border-bottom: 1px solid var(--tables-title-stroke);
}
.maintenanceTableTh__aVQoj:first-child {
  padding-left: 25px;
}
.maintenanceTableTh__aVQoj:last-child {
  padding-right: 25px;
}

.maintenanceTableBodyRow__oy3FP {
  background: var(--tables-secondary-row-sub-title-surface);
}

.maintenanceTableTd__W9KNc {
  font-size: 14px;
  line-height: 17px;
  padding: 10px 15px 10px 0;
  border-bottom: 1px solid var(--tables-primary-row-stroke);
}
.maintenanceTableTd__W9KNc:first-child {
  padding-left: 25px;
}
.maintenanceTableTd__W9KNc:last-child {
  padding-right: 25px;
}

.severityTd__JvXI1 {
  width: 200px;
}

.tableText__nXPaU {
  font-size: 11px;
  font-weight: 500;
  line-height: 35px;
  color: var(--tabs-text-active);
  text-align: center;
  border-radius: 2px;
  border: 1px solid var(--tabs-stroke-default);
  background: var(--tabs-surface-active);
}

.tableField__teHGY {
  height: 35px;
  padding: 11px 15px;
  color: var(--inputs-filled-text);
  display: flex;
  align-items: center;
  border: 1px solid var(--inputs-filled-stroke);
  background: var(--inputs-default-surface-default-2);
  border-radius: 2px;
}`, "",{"version":3,"sources":["webpack://./../src/pages/ActionItem/components/MaintenanceDetails/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,WAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,iBAAA;EACA,yCAAA;EACA,yBAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,gBAAA;AAzEF;;AA4EA;EACE,uCAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,+BAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,mDAAA;AAzEF;AA2EE;EACE,kBAAA;AAzEJ;AA4EE;EACE,mBAAA;AA1EJ;;AA8EA;EACE,yDAAA;AA3EF;;AA8EA;EACE,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,yDAAA;AA3EF;AA6EE;EACE,kBAAA;AA3EJ;AA8EE;EACE,mBAAA;AA5EJ;;AAgFA;EACE,YAAA;AA7EF;;AAgFA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,8BAAA;EACA,kBAAA;EACA,kBAAA;EACA,4CAAA;EACA,sCAAA;AA7EF;;AAgFA;EACE,YAAA;EACA,kBAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,6CAAA;EACA,mDAAA;EACA,kBAAA;AA7EF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.maintenanceBlock {\n  width: 100%;\n}\n\n.maintenanceTitle {\n  font-size: 11px;\n  line-height: 13px;\n  color: var(--title-inputs-sections-title);\n  text-transform: uppercase;\n}\n\n.maintenanceTable {\n  width: 100%;\n  margin-top: 10px;\n}\n\n.maintenanceTableHead {\n  background: var(--tables-title-surface);\n}\n\n.maintenanceTableTh {\n  font-size: 10px;\n  font-weight: 400;\n  line-height: 12px;\n  color: var(--tables-title-text);\n  text-transform: uppercase;\n  text-align: left;\n  padding: 15px 0;\n  border-bottom: 1px solid var(--tables-title-stroke);\n\n  &:first-child {\n    padding-left: 25px;\n  }\n\n  &:last-child {\n    padding-right: 25px;\n  }\n}\n\n.maintenanceTableBodyRow {\n  background: var(--tables-secondary-row-sub-title-surface);\n}\n\n.maintenanceTableTd {\n  font-size: 14px;\n  line-height: 17px;\n  padding: 10px 15px 10px 0;\n  border-bottom: 1px solid var(--tables-primary-row-stroke);\n\n  &:first-child {\n    padding-left: 25px;\n  }\n\n  &:last-child {\n    padding-right: 25px;\n  }\n}\n\n.severityTd {\n  width: 200px;\n}\n\n.tableText {\n  font-size: 11px;\n  font-weight: 500;\n  line-height: 35px;\n  color: var(--tabs-text-active);\n  text-align: center;\n  border-radius: 2px;\n  border: 1px solid var(--tabs-stroke-default);\n  background: var(--tabs-surface-active);\n}\n\n.tableField {\n  height: 35px;\n  padding: 11px 15px;\n  color: var(--inputs-filled-text);\n  display: flex;\n  align-items: center;\n  border: 1px solid var(--inputs-filled-stroke);\n  background: var(--inputs-default-surface-default-2);\n  border-radius: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"maintenanceBlock": `maintenanceBlock___M3Q5`,
	"maintenanceTitle": `maintenanceTitle__p2PAH`,
	"maintenanceTable": `maintenanceTable__daZBl`,
	"maintenanceTableHead": `maintenanceTableHead__RW9Nr`,
	"maintenanceTableTh": `maintenanceTableTh__aVQoj`,
	"maintenanceTableBodyRow": `maintenanceTableBodyRow__oy3FP`,
	"maintenanceTableTd": `maintenanceTableTd__W9KNc`,
	"severityTd": `severityTd__JvXI1`,
	"tableText": `tableText__nXPaU`,
	"tableField": `tableField__teHGY`
};
module.exports = ___CSS_LOADER_EXPORT___;
